import { TaghvimSaleSakhtEnum } from 'Feature/Khodro/Common/Enums/TaghvimSaleSakhtEnum';

import IVehicleInfoDto from '../../../../../../../../Feature/Khodro/ShakhsSales/SakhsSalesBimehNameh/Commands/Estelam/IVehicleInfoDto';

const VehicleInfoInitialState: IVehicleInfoDto = {
  noeVasilehNaghleyeh: undefined,
  noePelakCoreId: undefined,
  moredEstefadehCoreId: undefined,
  tipCoreId: undefined,
  brandCoreId: undefined,
  taghvimSaleSakht: TaghvimSaleSakhtEnum.Shamsi,
  sefrKiloometr: undefined,
  saleSakht: undefined,
};

export default VehicleInfoInitialState;
